import {
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@material-ui/core"
import { Search } from "@material-ui/icons"
import { useSnackbar } from "notistack"
import { useEffect, useState } from "react"
import { RegistrarLogErro } from "../../../services/clientefiel"
import { detalhesMesa, listarMesasDiario, reabrirMesa } from "../../../services/integracao"
import useLoadingStore from "../../../stores/LoadingStore"
import Cabecalho from "../../Cabecalho"
import DialogDetalhesDaMesa from "./DialogDetalhesDaMesa"

const useStyles = makeStyles({
    subtituloDialog: {
        marginBottom: "0.5em",
        fontWeight: "bold",
    },
    botaoFecharDialog: {
        backgroundColor: "red",
        color: "white",
        "&:hover": {
            backgroundColor: "#b30000",
        },
    },
    botaoImprimir: {
        backgroundColor: "#007bff",
        color: "white",
        "&:hover": {
            backgroundColor: "#0056b3",
        },
    },

    container: {
        margin: "auto",
        marginTop: "6em",
        maxWidth: "1000px",
    },
    busca: {
        display: "flex",
        alignItems: "center",
        gap: "0.5em",
    },
    containerItemLista: {
        borderRight: "solid 1px rgba(0,0,0,0.4)",

        "@media (max-width: 600px)": {
            borderRight: 0,
        },
    },
    itemListaEsqueleto: {
        fontWeight: "bold",
        paddingInline: "0.5em",
        width: "100%",

        "@media (max-width: 600px)": {
            paddingInline: 0,
        },
    },
    itemLista: {
        paddingInline: "0.5em",
        "@media (max-width: 600px)": {
            paddingInline: 0,
        },
    },
})

const hoje = new Date()
const hojeSP = new Date(hoje.getTime() - 3 * 60 * 60 * 1000)
let [ano, mes, dia] = hojeSP.toISOString().split("T")[0].split("-")
let dataDigitada = `${dia}/${mes}/${ano}`

const mesas = new Array(50).fill().map((_, i) => i + 1)

const MesasFechadas = () => {
    const autorizacao = localStorage.getItem("chaveSistema")
    const setLoading = useLoadingStore(s => s.setLoading)
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }
    const classes = useStyles()

    const [listaMesaDiario, setListaMesaDiario] = useState([])
    const [mesaDialog, setMesaDialog] = useState({})
    const [openDialog, setOpenDialog] = useState(false)
    const handleToggleOpenDialog = () => {
        setOpenDialog(prev => !prev)
    }
    const [mesaSelecionada, setMesaSelecionada] = useState("")
    const handleMesaSelecionada = mesa => {
        setMesaSelecionada(mesa)
    }

    const horarioFormatado = horario => {
        const horarioFormatado = new Date(horario)
        const horas = horarioFormatado.getHours().toString().padStart(2, "0")
        const minutos = horarioFormatado.getMinutes().toString().padStart(2, "0")

        return `${horas}:${minutos}`
    }

    const dataFormatada = date => {
        const [dia, mes, ano] = date.split("/")
        return `${ano}-${mes}-${dia}`
    }

    const buscarMesasDiario = async () => {
        try {
            setLoading(true)

            const response = await listarMesasDiario(
                dataFormatada(dataDigitada),
                mesaSelecionada,
                autorizacao
            )

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                setListaMesaDiario(response)
            }
        } catch (error) {
            alertStart(error.message, "error")
        } finally {
            setLoading(false)
        }
    }

    const handleDetalhesMesa = async idMesa => {
        try {
            setLoading(true)
            const response = await detalhesMesa(idMesa, autorizacao)

            if (response.retornoErro) {
                alertStart("Erro ao buscar os detalhes da mesa", "error")
                throw new Error(response.mensagem)
            }
            setMesaDialog(response)
        } catch (error) {
            console.error(error)
            RegistrarLogErro(error, "handleDetalhesMesa")
            throw error
        } finally {
            setLoading(false)
        }
    }

    const handleReabrirMesa = async idMesa => {
        try {
            setLoading(true)
            const response = await reabrirMesa(idMesa)
            if (response?.retornoErro) {
                console.log(response)
                alertStart("Erro ao reabrir mesa", "error")
                return
            }
            window.location.reload()
        } catch (error) {
            console.log(error)
            RegistrarLogErro(error, "handleReabrirMesa")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        buscarMesasDiario()
    }, [])

    const totalTaxaServico = listaMesaDiario.reduce(
        (acc, mesaDia) => acc + (Number(mesaDia?.valorAdicional) || 0),
        0
    )

    return (
        <>
            <DialogDetalhesDaMesa
                openDialog={openDialog}
                mesaDialog={mesaDialog}
                handleToggleOpenDialog={handleToggleOpenDialog}
                classes={classes}
                handleReabrirMesa={handleReabrirMesa}
            />
            <div>
                <Cabecalho pagina="Histórico de mesas" />
                <div className={classes.container}>
                    <div className={classes.busca}>
                        <TextField
                            variant="outlined"
                            size="small"
                            label="Dia"
                            defaultValue={dataDigitada}
                            onChange={e => {
                                dataDigitada = e.target.value
                            }}
                        />
                        <FormControl style={{ width: "6em" }} variant="outlined" size="small">
                            <InputLabel>Mesa</InputLabel>
                            <Select
                                label="Mesa"
                                value={mesaSelecionada}
                                onChange={e => handleMesaSelecionada(e.target.value)}
                            >
                                <MenuItem value="">Todas</MenuItem>
                                {mesas.map((mesa, i) => (
                                    <MenuItem key={i} value={mesa}>
                                        {mesa}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <IconButton
                            onClick={() => {
                                buscarMesasDiario()
                            }}
                        >
                            <Search />
                        </IconButton>
                    </div>
                    <hr />
                    <div id="vaiVirarComponente">
                        <Grid>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Grid
                                    item
                                    xs={2}
                                    sm={1}
                                    md={1}
                                    className={classes.containerItemLista}
                                >
                                    <Typography className={classes.itemListaEsqueleto}>
                                        Mesa
                                    </Typography>
                                </Grid>

                                <Grid
                                    item
                                    xs={3}
                                    sm={2}
                                    md={2}
                                    className={classes.containerItemLista}
                                >
                                    <Typography className={classes.itemListaEsqueleto}>
                                        Abertura
                                    </Typography>
                                </Grid>

                                <Grid
                                    item
                                    xs={3}
                                    sm={2}
                                    md={2}
                                    className={classes.containerItemLista}
                                >
                                    <Typography className={classes.itemListaEsqueleto}>
                                        Fechamento
                                    </Typography>
                                </Grid>

                                <Grid
                                    item
                                    xs={2}
                                    sm={2}
                                    md={2}
                                    className={classes.containerItemLista}
                                >
                                    <Typography className={classes.itemListaEsqueleto}>
                                        Valor
                                    </Typography>
                                </Grid>

                                <Grid
                                    item
                                    xs={2}
                                    sm={2}
                                    md={2}
                                    className={classes.containerItemLista}
                                >
                                    <Typography className={classes.itemListaEsqueleto}>
                                        Taxa de serviço
                                    </Typography>
                                </Grid>

                                <Grid item xs={0} sm={2} md={2}>
                                    <Typography className={classes.itemListaEsqueleto}>
                                        Detalhes
                                    </Typography>
                                </Grid>
                            </Grid>
                            <hr />
                            {listaMesaDiario.map((mesaDia, i) => {
                                return (
                                    <div key={i}>
                                        <Grid
                                            container
                                            alignItems="center"
                                            justifyContent="space-between"
                                        >
                                            <Grid
                                                item
                                                xs={2}
                                                sm={1}
                                                md={1}
                                                className={classes.containerItemLista}
                                            >
                                                <Typography className={classes.itemLista}>
                                                    {mesaDia.numeroMesa}
                                                </Typography>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={3}
                                                sm={2}
                                                md={2}
                                                className={classes.containerItemLista}
                                            >
                                                <Typography className={classes.itemLista}>
                                                    {horarioFormatado(mesaDia.dataAbertura)}
                                                </Typography>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={3}
                                                sm={2}
                                                md={2}
                                                className={classes.containerItemLista}
                                            >
                                                <Typography className={classes.itemLista}>
                                                    {mesaDia?.dataFechamento
                                                        ? horarioFormatado(mesaDia.dataFechamento)
                                                        : "Mesa Aberta"}
                                                </Typography>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={2}
                                                sm={2}
                                                md={2}
                                                className={classes.containerItemLista}
                                            >
                                                <Typography className={classes.itemLista}>
                                                    {mesaDia?.pagamentos
                                                        ?.reduce(
                                                            (total, pagamento) =>
                                                                total + pagamento.valor,
                                                            0
                                                        )
                                                        ?.toFixed(2)
                                                        ?.replace(".", ",")}
                                                </Typography>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={2}
                                                sm={2}
                                                md={2}
                                                className={classes.containerItemLista}
                                            >
                                                <Typography className={classes.itemLista}>
                                                    {Intl.NumberFormat("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL",
                                                    }).format(mesaDia?.valorAdicional ?? 0)}
                                                </Typography>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={2}
                                                sm={2}
                                                md={2}
                                                style={{ paddingInline: "1em" }}
                                            >
                                                <IconButton
                                                    size="small"
                                                    onClick={async () => {
                                                        await handleDetalhesMesa(mesaDia.id)
                                                        handleToggleOpenDialog()
                                                    }}
                                                >
                                                    <Search />
                                                </IconButton>
                                            </Grid>
                                        </Grid>

                                        <hr />
                                    </div>
                                )
                            })}
                            {listaMesaDiario.length > 0 && (
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid
                                        item
                                        xs={2}
                                        sm={1}
                                        md={1}
                                        className={classes.containerItemLista}
                                    >
                                        <Typography className={classes.itemListaEsqueleto}>
                                            Total
                                        </Typography>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={3}
                                        sm={2}
                                        md={2}
                                        className={classes.containerItemLista}
                                    >
                                        <Typography className={classes.itemListaEsqueleto}>
                                            -
                                        </Typography>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={3}
                                        sm={2}
                                        md={2}
                                        className={classes.containerItemLista}
                                    >
                                        <Typography className={classes.itemListaEsqueleto}>
                                            -
                                        </Typography>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={2}
                                        sm={2}
                                        md={2}
                                        className={classes.containerItemLista}
                                    >
                                        <Typography className={classes.itemListaEsqueleto}>
                                            -
                                        </Typography>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={2}
                                        sm={2}
                                        md={2}
                                        className={classes.containerItemLista}
                                    >
                                        <Typography className={classes.itemListaEsqueleto}>
                                            {Intl.NumberFormat("pt-BR", {
                                                style: "currency",
                                                currency: "BRL",
                                            }).format(totalTaxaServico)}
                                        </Typography>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={2}
                                        sm={2}
                                        md={2}
                                        style={{ paddingInline: "1em" }}
                                    >
                                        <Typography
                                            className={classes.itemListaEsqueleto}
                                        ></Typography>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MesasFechadas
